import { type HttpHandler, http, HttpResponse } from 'msw';

import type { FleetStartVerificationRequest, FleetRef } from '../../../domain/fleet-verification';

const createFleetVerificationApplicationHandler = (isError?: boolean) =>
  http.post<never, FleetStartVerificationRequest, never>('/fleet-verification/start-verification', () => {
    if (isError) {
      throw new HttpResponse(null, { status: 400 });
    } else {
      return new HttpResponse(undefined, { status: 204 });
    }
  });

const getFleetsHandler = (fleets?: FleetRef[]) =>
  http.get<never, never, FleetRef[]>('/fleet-verification/fleets', () => {
    return HttpResponse.json(
      fleets ?? [
        {
          id: 'flt_101',
          name: 'Cobra Kai',
          status: 'not_started',
        },
        {
          id: 'flt_102',
          name: 'Eagle Fang Karate',
          status: 'in_progress',
        },
      ],
    );
  });
const handlers: HttpHandler[] = [createFleetVerificationApplicationHandler(), getFleetsHandler()];

export { handlers };
